/** @format */

import React from "react";
import serviceImage from "../assets/services-image.png";
import CardBox from "./landing/CardBox";
import Subtitle from "./landing/Subtitle";
import Title from "./landing/Title";

const services = [
  {
    number: "01",
    title: "FITNESS TRAINING",
    summary:
      "Forget about going to the gym. Burn calories, build endurance and strengthen your muscles at home.",
  },
  {
    number: "02",
    title: "FITNESS ANALYSIS",
    summary:
      "Keep a close eye on your exercise metrics and create concrete plans for losing weight and staying fit.",
  },
  {
    number: "03",
    title: "STRESS MANAGEMENT",
    summary:
      "Nothing like one of our relaxing routines to help you ramp down after a long day.",
  },
  {
    number: "04",
    title: "HEALTH MANAGEMENT",
    summary:
      "Balance out your demanding job with exercises that promote a healthy lifestyle.",
  },
];

const Services = () => {
  return (
    <div className="our-services-bg pt-[91px] flex flex-col" id="services">
      <div className="flex flex-col justify-center items-center">
        <Title title="OUR SERVICES" titleClass="title-text" />
        <Subtitle summary="Explore some of the ways FitStats allows you to get in shape from home" />
      </div>
      <div className="services-bg pt-[73px] flex lg:flex-row flex-col justify-between lg:items-start items-center gap-[18px] lg:pb-10 pb-20 xl:px-24 px-8">
        <div className="hidden lg:block">
          <img
            src={serviceImage}
            alt="serviceImage"
            className="absolute left-0 bottom-0 w-auto"
          />
        </div>

        <div className="relative">
          <div className="xl:bg-transparent lg:bg-black opacity-50 absolute w-full h-full right-0 rounded-md"></div>
          <div className="grid md:grid-cols-[1fr,1fr] md:gap-x-[100px] gap-y-[70px]  text-white xl:px-0 lg:px-10 xl:py-0 lg:py-10">
            {services &&
              services.map((cardItem, key) => (
                <CardBox
                  key={key}
                  number={cardItem.number}
                  title={cardItem.title}
                  summary={cardItem.summary}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
